module.exports = __webpack_public_path__ + "img/hr-level2addon_dead_shadow.80bc7a39.png";